import React from 'react';
import classNames from 'classnames';

export const Price: React.FC<{ className?: string }> = ({ children, className }) => (
  <h3 className={classNames('text-high-emphasis text-xl font-semibold m-0 leading-none', className)}>
    {children}
  </h3>
);

export const PriceAddon: React.FC = ({ children }) => (
  <span className="text-gray-600 text-sm font-normal">{children}</span>
);
